var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.permiteCancelarEnvioParaAnalise)?_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-ban fa-lg icon-button mr-1",attrs:{"title":"Cancelar Envio para análise"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarCancelarEnvioParaAnalise()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }